import FinalScore from './FinalScore.component';

export default FinalScore;
